import React, { useState, useEffect, useContext } from "react";
import "./Workouts.scss";
import AddButton from "../../components/_default/AddButton";
import logo from '../../assets/images/logo.svg';

//testimages
import aurum from "../../assets/images/aurum.png";
import DropDown from "../../components/_default/DropDown";
import LongList from "../../components/_default/LongList";
import SearchPage from "../../components/_default/SearchPage";
import { getWorkoutsAurum, getWorkoutsCoach } from "../../services/firebase/firestore/getData";
import { deleteWorkoutAurum, deleteWorkoutCoach } from "../../services/firebase/firestore/deleteData";
import Popup from "../../components/_default/Popup";
import { deleteMediaArrayFromStorage } from "../../services/firebase/storage";
import UserContext from "../../services/context/userContext";
import { useCookies } from "react-cookie";

function Workouts(props) {
  const [cookies, setCookie] = useCookies(["from"]);

  const [workouts, setWorkouts] = useState(false);
  const [initialWorkouts, setInitialWorkouts] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [from, setFrom] = useState(cookies.from ? cookies.from : "aurum");

  const filters = ["Sort by name", "Sort by category"];
  const [filter, setFilter] = useState("Sort by name");
  const filterTypes = ["Ascending", "Descending"];
  const [filterType, setFilterType] = useState("Ascending");
  const [copyObj,setCopyObj]=useState({})

  const user = useContext(UserContext);

  useEffect(() => {
    getWorkouts();
  }, [filter, filterType]);

  useEffect(() => {
    setCookie("from", from, { path: "/" });
  }, [from]);

  function sorter(workouts) {
    if(workouts.aurum) {
      workouts.aurum.sort((a,b) => {
        let firstCheck = filter === "Sort by category"? a.category : a.name;
        let secondCheck = filter === "Sort by category"? b.category : b.name;
        if (firstCheck > secondCheck) {
          return filterType == "Ascending"? 1 : -1;
        }
        if (secondCheck > firstCheck) {
          return filterType == "Ascending"? -1 : 1;
        }
          return 0;
        });
    }
    if(workouts.coach) {
      workouts.coach.sort((a,b) => {
        let firstCheck = filter === "Sort by category"? a.category : a.name;
        let secondCheck = filter === "Sort by category"? b.category : b.name;
        if (firstCheck > secondCheck) {
          return filterType == "Ascending"? 1 : -1;
        }
        if (secondCheck > firstCheck) {
          return filterType == "Ascending"? -1 : 1;
        }
        return 0;
      });
    }
   
    setWorkouts(workouts);
  }

  function getWorkouts() {
    getWorkoutsAurum((aurum_result) => {
      getWorkoutsCoach(user.id, (coach_result) => {
        sorter({ aurum: aurum_result, coach: coach_result });
        // setWorkouts({ aurum: aurum_result, coach: coach_result });
        setInitialWorkouts({ aurum: aurum_result, coach: coach_result });
        setShowPopup(false);
      });
    });
  }

  function removeWorkout(e) {
    deleteMediaArrayFromStorage([e.image], () => {
      if(from === "aurum"){
        deleteWorkoutAurum(e.id, () => {
          getWorkouts();
        });
      }else{
        deleteWorkoutCoach(user.id, e.id, () => {
          getWorkouts();
        });
      }
    });
  }

  function searchWorkoutsByName(e) {
    getWorkoutsAurum((aurum_result) => {
      getWorkoutsCoach(user.id, (coach_result) => {
        sorter({ aurum: aurum_result, coach: coach_result });
        let finalResult = { aurum: [], coach: [] };
        if(workouts.aurum){
          workouts.aurum.map((item) => {
            if(item.name.toLowerCase().includes(e.target.value.toLowerCase())) {
              finalResult.aurum.push(item);
            }
          })
        }
        
        workouts.coach.map((item) => {
          if(item.name.toLowerCase().includes(e.target.value.toLowerCase())) {
            finalResult.coach.push(item);
          }
        });

        if(e.target.value === "") {
          sorter({ aurum: aurum_result, coach: coach_result });
        }else {
          sorter(finalResult);
        }  
        setShowPopup(false);
      });
    });

  }

  return (
    <div className="c-page-wrapper c-page-dashboard" style={{justifyContent: 'flex-start'}}>
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav">
            <h1 className="c-header-title">Workouts</h1>
            <ul className="c-header-nav-wrapper">
              <li className={from === "aurum" ? "--active" : ""} onClick={() => setFrom("aurum")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${aurum}')` }} />
                <p>Aurum <span>({initialWorkouts.aurum ? initialWorkouts.aurum.length : 0})</span></p>
              </li>

              <li className={from === "coach" ? "--active" : ""} onClick={() => setFrom("coach")}>
                <div className="c-side-user-image" style={{ backgroundImage: `url('${user.image}')` }}>
                  <p>{user.first_name[0] + user.last_name.match(/\b(\w)/g).join("")}</p>
                </div>
                <p>{user.first_name} <span>({initialWorkouts.coach ? initialWorkouts.coach.length : 0})</span> </p>
              </li>
            </ul>
          </div>
          <div className="c-header-add">
            <AddButton text="Add Workout" backgroundColor="#FFC415" color="#000" onClick={() => props.history.push("/workout", { update: false, from: from })} />
          </div>
          <div className="c-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      <div className="c-page-wrapper--exercises">
        <div className="c-page-main--exercises">
          <div className="c-exercise-finder">
            <SearchPage placeholder="Search workout" onChange={(e) => {searchWorkoutsByName(e)}} />
            <div className="c-dropdown-holder">
              <DropDown options={filters} value={filter} onChange={(e) => setFilter(e)} zindex={66}/>
              <DropDown options={filterTypes} value={filterType} onChange={(e) => setFilterType(e)} zindex={66}/>
            </div>
          </div>
          <LongList from={from}  pagetype="workout" history={props.history} items={workouts[from]} removeItem={(e) => setShowPopup({ type: "workout", ...e })} />
        </div>
      </div>

      {showPopup && (
        <Popup
          title={"Delete workout"}
          button="Delete"
          deletePopup={true}
          description={"Are you sure you want to delete this workout? This can not be undone."}
          onAction={() => removeWorkout(showPopup)}
          onCancel={() => {
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
}

export default Workouts;
